import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendarCheck4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calendar-check-4"} maskId="square-filled-radius-0-stroke-1-IconCalendarCheck4"><path fillRule="evenodd" clipRule="evenodd" d="M7 4H3V21H21V4H17V2H16V4H8V2H7V4ZM15.7071 10.325L10.65 15.3821L8.29289 13.025L9 12.3179L10.65 13.9679L15 9.61791L15.7071 10.325Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalendarCheck4;
